import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router";

import Box from '@mui/material/Box';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { actionCreators } from 'store/User';

import { ReactComponent as IconUser } from 'assets/images/icon_user.svg';
import { UserRoleEnum } from 'api';
import { Routes } from 'shared/constants/routes';

const UserMenu: React.FC = () => {
  const userData = useSelector(state => state.user.data);
  const { fullName, userRole } = userData;
  const isTariffShown = userRole === UserRoleEnum.Owner;
  const dispatch = useDispatch();
  const history = useHistory();

  const onChange = (e: SelectChangeEvent) => {
    switch (e.target.value) {
      case 'logout':
        return dispatch(actionCreators.logout());
      case 'tariff':
        return history.push(Routes.subscription);

      default:
        break;
    }
  };

  return (
    <Select
      size='small'
      sx={{
        '.MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          boxShadow: 'none',
        },
      }}
      value=''
      displayEmpty
      onChange={onChange}
      renderValue={() => {
        return (
          <Box display='flex' alignItems='center'>
            <Box mr={1}><IconUser /></Box>
            {fullName}
          </Box>
        );
      }}
    >
      {isTariffShown && <MenuItem value='tariff'>Мій тариф</MenuItem>}
      <MenuItem value='logout' sx={{ color: (theme) => theme.colors.secondaryRed }}>
        Вийти
      </MenuItem>
    </Select>
  );
};

export default UserMenu;
